import { render } from "./GraphRive.vue?vue&type=template&id=b5ef84d2&scoped=true"
import script from "./GraphRive.vue?vue&type=script&lang=js"
export * from "./GraphRive.vue?vue&type=script&lang=js"

import "./GraphRive.vue?vue&type=style&index=0&id=b5ef84d2&scoped=true&lang=css"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5ef84d2"]])

export default __exports__